<template>
  <div class="cardcommon__component" :style="{'width': width ? width : '394px'}">
    <a class="cardcommon__link" @click="clickToOpenUrlFn(data, $event)">
      <div class="cardcommon__top-part">
        <h3 class="cardcommon__title">
          <span class="icon" :class="item.id == 12 ? 'presale' : 'solid'" v-for="(item, index) in data.saleLabel" :key="index">{{ item.name }}</span>
          <span class="icon solid" v-if="data.isPackageCourse">
            {{ data.isClassBegin ? '已开课' : '未开课' }}
          </span>
          <span class="icon" v-if="data.subjects[0].name">
            {{ data.subjects[0].name }}
          </span>
          <span v-html="data.name"></span>
        </h3>

        <div class="cardcommon__label">
          <p class="info" v-if="data.schoolTimeName" :title="data.schoolTimeName">
            <span class="time-icon"></span>{{ data.schoolTimeName }}
          </p>
          <p class="info" v-if="data.answerLiveTimeDesc" :title="data.answerLiveTimeDesc">
            <span class="time-icon"></span>{{ data.answerLiveTimeDesc }}
          </p>
        </div>

        <div class="cardcommon__teachers">
          <!-- 中教老师 -->
          <div class="teacher" v-if="data.chineseTeacher && data.chineseTeacher[0]">
            <div class="avatar" :style="{ backgroundImage: `url(${data.chineseTeacher[0].avatars && data.chineseTeacher[0].avatars[0]})` }"></div>
            <p class="job">{{ data.chineseTeacher[0].typeName }}</p>
            <p class="name">{{ data.chineseTeacher.length > 1 ? data.chineseTeacher[0].name + '等' : data.chineseTeacher[0].name }}</p>
          </div>
          <!-- 外教老师 -->
          <div class="teacher" v-if="data.foreignTeacher && data.foreignTeacher[0] && data.foreignTeacher[0].name && data.foreignTeacher[0].typeName">
            <div class="avatar" :style="{ backgroundImage: `url(${data.foreignTeacher[0].avatars && data.foreignTeacher[0].avatars[0]})` }"></div>
            <p class="job">{{ data.foreignTeacher[0].typeName }}</p>
            <p class="name">{{ data.foreignTeacher.length > 1 ? data.foreignTeacher[0].name + '等' : data.foreignTeacher[0].name }}</p>
          </div>
          <!-- 专属/辅导（班主任）老师 -->
          <div class="teacher" v-if="data.isHaveCounselorTeacher === 1 &&
              data.class.counselor">
            <!--
             &&
              data.class.leftNum
             &&
              data.class.leftNum !== 0
            -->
            <div class="avatar" :style="{ backgroundImage: `url(${data.class.counselor.avatars && data.class.counselor.avatars[0]})` }"></div>
            <template v-if="data.excTeacherCourse && data.excTeacherCourse === 1">
              <p class="job"></p>
              <p class="name">专属老师</p>
            </template>
            <template v-else>
              <p class="job">{{ data.class.counselor.typeName }}</p>
              <p class="name">{{ data.class.counselor.name }}</p>
              <div
                class="label"
                v-if="data.class.leftNum && data.class.leftNum !== 0"
              >
                余{{ data.class.leftNum }}名额
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="cardcommon__info">
        <div class="left-part">
          <div class="desc" v-if="data.saletimes.countDown">{{ data.saletimes.countDown }}</div>
          <div class="num">共{{ data.syllabusNum }}讲</div>
        </div>

        <div class="price" v-if="!data.isFull">
          <span class="origin" v-if="Number(data.price.resale) !== 0 && data.price.resale != data.price.origin">￥{{ data.price.origin }}</span>
          <span class="icon" v-if="Number(data.price.resale) !== 0">￥</span><span :class="['icon', { 'try-class': Number(data.price.resale) === 0}]">{{ Number(data.price.resale) === 0 ? '体验课' : data.price.resale }}</span>
        </div>
        <div class="full" v-if="+data.isFull === 1">已报满</div>
      </div>
    </a>
  </div>
</template>

<script>
import qs from 'qs'
import jsCookie from 'js-cookie'

export default {
  name: 'CourseCard',
  props: ['data', 'courseType', 'index', 'keyName', 'clickId', 'termId', 'width'],
  methods: {
    computedSubjectFn (subjectId) {
      const subjectEnmuString = window.localStorage.getItem('__xes__subject__enum__')
      const subjectEnmu = JSON.parse(subjectEnmuString)
      if (subjectId === 0) return '-1'
      for (let key in subjectEnmu) {
        if (subjectEnmu[key] === subjectEnmu[subjectId] && key > -1) {
          return key
        }
      }
      return '-1'
    },
    computedRouterQueryFn (data) {
      const routeQuery = this.$route.query

      const grade = jsCookie.get('userGrade') || -1
      const subject = this.computedSubjectFn(data.subjects[0].id)
      const { switch_grade = grade, switch_subject = subject } = routeQuery

      const query = {
        ...routeQuery,
        switch_grade,
        switch_subject
      }
      return query
    },
    clickToOpenUrlFn (data, e) {
      const query = this.computedRouterQueryFn(data)
      const courseId = data.id
      const classId = data.class.id
      let url = 'https://online.xueersi.com/course-detail'
      if (courseId) url += '/' + courseId
      if (classId) url += '/' + classId
      let queryStr = qs.stringify(query)
      url += '?' +  queryStr
      window.open(url)

      const XESLog = new this.$XESLog({
        key: this.keyName,
        clickid: this.clickId,
        content: this.data,
        courseid: this.data.id,
        rankid: this.index,
        termid: this.termId,
        gradeid: this.$route.params.grade,
        subjectid: this.data.subjects[0].id,
        clickurl: `https://online.xueersi.com/course-detail/${this.data.id}`
      })
      XESLog.push({ eventname: 'click', target: event.target }, this.$route)
    },
  },
}
</script>

<style lang="scss" scoped>
.cardcommon__component {
  // width: 394px;
  height: 373px;
  display: inline-block;
  box-sizing: border-box;
  margin: 8px 4.5px;
  position: relative;
  transition: all 0.2s linear;
  background-color: #ffffff;
  overflow: hidden;
  box-shadow: 0px 1px 3px 0px rgba(185, 189, 203, 0.32);
  border-radius: 2px;
  border: 1px solid #E5E5E5;

  &:hover {
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.05), -5px 0px 10px rgba(0, 0, 0, 0.05);
    border-top-color: #f13232;
    transform: translate3d(0, -4px, 0);
  }

  p {
    margin: 0; padding: 0;
  }
}

$c: ".cardcommon__component .cardcommon__link";

#{$c} {
  width: 100%;
  height: 100%;
  cursor: pointer;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  box-sizing: border-box;
}

#{$c} .cardcommon__top-part {
  padding: 32px 27px 0 27px;
}

#{$c} .cardcommon__title {
  margin: 0;
  white-space: normal;
  word-break: break-all;
  height: 52px;
  line-height: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin-bottom: 7px;
}

#{$c} .cardcommon__title span {
  vertical-align: middle;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: bold;
}

#{$c} .cardcommon__title .icon {
  padding: 0px 4px;
  min-width: 18px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  display: inline-block;
  margin-right: 7px;
  background-color: #DCAF80;
  border-radius: 2px;

  &.solid {
    color: #fff;
    background-color: #f13232;
  }

  &.presale {
    color: #fff;
    background-color: #ed773c;
  }

  &.hollow {
    color: #f13232;
    border: 1px solid #f13232;
  }
}

#{$c} .try-class {
  font-size: 24px!important;
}

#{$c} .cardcommon__label {
  margin-top: 13px;
  height: 70px;
  overflow: hidden;
  font-size: 14px;
  margin-bottom: 5px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #333333;

  .info {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    margin: 2px 0;
    text-overflow: ellipsis;
    &:last-child {
      margin-top: 5px;
    }

    // .time-icon {

    // }
  }
}

#{$c} .cardcommon__teachers {
  .teacher {
    display: inline-block;
    // height: 105px;
    margin-right: 37px;
    text-align: center;
    width: 62px;
    position: relative;
    &:last-child {
      margin-right: 0;
    }
  }

  .teacher .avatar {
    width: 57px;
    height: 57px;
    background-size: cover;
    border-radius: 50%;
    font-size: 0;
    text-align: center;
    overflow: hidden;
    background-color: #F6F7F7;
  }

  .teacher p {
    margin-top: 7px;
    text-align: center;
    color: #666666;
    font-size: 14px;
    height: 17px;
    line-height: 17px;
    overflow: hidden;


  }

  .teacher .name {
    margin-top: 0;
  }

  .teacher .label{
    position: absolute;
    right: -74px;
    top: 0px;
    max-width: 120%;
    text-align: center;
    background-image: url('//res12.xesimg.com/x5mall/img/student_num_label.png?20171211');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    width: 74px;
    height: 23px;
    font-size: 12px;
    line-height: 23px;
    color: #f0773c;
  }
}

#{$c} .cardcommon__info {
  margin-top: 29px;
  border-top: 1px solid rgba(229, 229, 229, 1);
  height: 84px;
  box-sizing: border-box;
  width: 100%;
  padding: 0px 26px 0px 28px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left-part{
    .desc {
      font-size: 14px;
      line-height: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #999999;
    }

    .num {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      line-height: 16px;
      color: #999999;
    }
  }



  .full {
    font-size: 20px;
    color: #666;
  }

  .price {
    color: #E02727;
    font-size: 14px;
    font-weight: bold;
  }

  .price .icon{
    font-size: 14px;
    display: inline-block;
    vertical-align: middle;
    padding-bottom: 5px;
  }

  .price strong {
    color: #E02727;
    font-size: 36px;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
  }

  .price .origin {
    display: inline-block;
    vertical-align: middle;
    padding-bottom: 4px;
    font-size: 14px;
    font-family: Arial;
    opacity: 0.8;
    color: #999;
    text-decoration: line-through;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/CourseCard.vue